import environment from '../environment';
// This initializer automatically instantiates the environment object and
// registers it in the container.
export function initialize(instance) {
  if (!instance.lookup('environment:current')) {
    const environmentInstance = environment();
    instance.registerOptionsForType('environment', {
      instantiate: false,
      singleton: true
    });
    instance.register('environment:current', environmentInstance);
  }
}
export default {
  initialize
};